import { jsx as _jsx } from "react/jsx-runtime";
import { useIntl } from 'react-intl';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { BriefcaseIcon, IndustryIcon, UserFaIcon } from '../../Icons';
import { MultiSelectButtons } from '../MultiSelectButtons';
export var FilterRelationTypeButtons = function (_a) {
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    var formatMessage = useIntl().formatMessage;
    return {
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(MultiSelectButtons, { options: [
                {
                    id: '0',
                    label: formatMessage(listItemMsg('relationType', 0, 'Company')),
                    icon: _jsx(IndustryIcon, {}),
                },
                {
                    id: '1',
                    label: formatMessage(listItemMsg('relationType', 1, 'Sole proprietor')),
                    icon: _jsx(BriefcaseIcon, {}),
                },
                {
                    id: '2',
                    label: formatMessage(listItemMsg('relationType', 2, 'Person')),
                    icon: _jsx(UserFaIcon, {}),
                },
            ], onChange: function (value) {
                var _a;
                var _b;
                return setFilter((_a = {},
                    _a[item] = ((_b = value === null || value === void 0 ? void 0 : value.length) !== null && _b !== void 0 ? _b : 0) > 0 ? value : undefined,
                    _a));
            }, selected: activeFilters[item], fullWith: true })),
    };
};
